/**
 * Replaces string placeholders with passed in components
 * @param {string} sourceString The string containing the placeholders
 * @param {generic} components One or more components the placeholders should be replaced with
 *
 * @returns {string} String with passed in components instead of placeholders
 * Example: replacePlaceholdersWithComponents('Follow this {0} to read more', <a href="link">link</a> ) => 'Follow this link to read more'
 *
 */
import React from 'react';
const isRenderableElement = (el) => {
    try {
        return !!(el instanceof Element || React.isValidElement(el));
    }
    catch (e) {
        return false;
    }
};
const replacePlaceholdersWithComponents = (sourceString, components) => {
    const pattern = /{[\d]}/g;
    const sentenceWithoutPlaceholders = sourceString.split(pattern);
    const placeholders = sourceString.match(pattern);
    if (sentenceWithoutPlaceholders.length <= 1 || !placeholders) {
        return sourceString;
    }
    if (Array.isArray(components)) {
        components.forEach((component) => {
            if (!isRenderableElement(component))
                throw new Error('Recieved invalid component');
        });
    }
    else if (!isRenderableElement(components))
        throw new Error('Recieved invalid component');
    const finalSentence = sentenceWithoutPlaceholders.reduce((sentenceParts, element, index) => {
        const placeholderValue = Array.isArray(components) ? components[index] : components;
        if (placeholders[index]) {
            return [...sentenceParts, element, placeholderValue];
        }
        return [...sentenceParts, element];
    }, []);
    return finalSentence;
};
export default replacePlaceholdersWithComponents;
//# sourceMappingURL=replacePlaceholdersWithComponents.js.map